export { default } from './Portal';
